// extracted by mini-css-extract-plugin
module.exports = {"trigger":"DashboardActions_trigger__3CNza","dropdown":"DashboardActions_dropdown__20-hH","link":"DashboardActions_link__1C3Ud","active":"DashboardActions_active__dYsdE"};